export default "__VITE_ASSET__CWR$j6eI__"